import axios, {AxiosResponse} from 'axios';
import {GetDiaryParams, GetDiaryResponse, PostNoteBody, ImageData, GetImagesResponse, UploadImagesResponse, DeleteImageResponse } from "../components/utilities/constants";

const url = process.env.REACT_APP_API_URL;


export default class childService {
    static getDiary(params: GetDiaryParams, id: string): Promise<GetDiaryResponse> {
        return axios.get(`${url}/child/${id}/diary`, { params }).then((response: AxiosResponse<GetDiaryResponse>) => {
            return response.data;
        });
    }

    static putDiary(params: PostNoteBody, noteId: string): Promise<any> {
        return axios.put(`${url}/note/${noteId}`, {
            notes: params.notes ?? undefined,
            activities: params.activities ?? undefined,
            food_first_course: params.food_first_course ?? undefined,
            food_second_course: params.food_second_course ?? undefined,
            food_side: params.food_side ?? undefined,
            food_merenda: params.food_merenda ?? undefined,
            feces_1_quality: params.feces_1_quality ?? undefined,
            feces_2_quality: params.feces_2_quality ?? undefined,
            feces_3_quality: params.feces_3_quality ?? undefined,
            milk: params.milk ?? undefined,
            nap_1_quality: params.nap_1_quality ?? undefined,
            nap_2_quality: params.nap_2_quality ?? undefined
        });
    }

    static postDiary(params: PostNoteBody, childId: string): Promise<any> {
        return axios.post(`${url}/child/${childId}/note`, {
            notes: params.notes ?? undefined,
            activities: params.activities ?? undefined,
            food_first_course: params.food_first_course ?? undefined,
            food_second_course: params.food_second_course ?? undefined,
            food_side: params.food_side ?? undefined,
            food_merenda: params.food_merenda ?? undefined,
            feces_1_quality: params.feces_1_quality ?? undefined,
            feces_2_quality: params.feces_2_quality ?? undefined,
            feces_3_quality: params.feces_3_quality ?? undefined,
            milk: params.milk ?? undefined,
            nap_1_quality: params.nap_1_quality ?? undefined,
            nap_2_quality: params.nap_2_quality ?? undefined
        });
    }

    /**
     * Ottiene tutte le immagini di una nota
     * @param noteId - ID della nota
     * @returns Promise con l'array delle immagini
     */
    static getImages(noteId: string): Promise<any> {
        return axios.get(`${url}/note/${noteId}/images`).then((response: AxiosResponse<any>) => {
            return response.data;
        });
    }

    /**
     * Carica nuove immagini per un bambino
     * @param formData - FormData contenente le immagini
     * @param noteId - ID della nota
     * @returns Promise con le immagini caricate
     */
    static uploadImages(formData: FormData, noteId: string): Promise<UploadImagesResponse> {
        return axios.post(`${url}/note/${noteId}/images`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }).then((response: AxiosResponse<UploadImagesResponse>) => {
            return response.data;
        });
    }

    /**
     * Elimina un'immagine specifica
     * @param imageId - ID dell'immagine da eliminare
     * @returns Promise con il messaggio di conferma
     */
    static deleteImage(imageId: string): Promise<void> {
        try {
            return axios.delete(`${url}/diary-note-images/${imageId}`);
        } catch (error) {
            console.log(error)
            return Promise.reject();
        }
    }
}